export default __webpack_public_path__ + "d72d07638257c37ceaa776391543e930.png";